"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppState = void 0;
const React = __importStar(require("react"));
const oneaudi_os_store_1 = __importDefault(require("@oneaudi/oneaudi-os-store"));
const Provider_1 = require("./Provider");
// type guard
function isInitFunction(init) {
    return typeof init === 'function';
}
function useAppState(init) {
    const Context = oneaudi_os_store_1.default.get(Provider_1.PROVIDER_KEY);
    const app = React.useContext(Context);
    const initialValue = isInitFunction(init)
        ? init()
        : (init ?? app?.data ?? {});
    const [state, setState] = React.useState(initialValue);
    // Force re-renders when app's data changes
    // useEffect will take care of unsubscribing
    React.useEffect(() => app?.subscribe(setState), [app]);
    // Setter for data in the Hypervisor registry
    const setData = (data) => {
        app.data = { ...state, ...data };
    };
    return [state, setData, app];
}
exports.useAppState = useAppState;
